import { catchError, switchMap, filter } from "rxjs/operators";
import { BEGIN_LMS_SESSION, logError, logDebugMessage, getCompletedSlides, getFavorites, setCurrentSlide, getKeyValueStore, setStudent, getExamData } from "../actions";
import { of } from "rxjs";
import { ofType } from "redux-observable";
var getSavedIdIfExists = function(id, nodes, state) {
    var isPresent = nodes.map(function(n) {
        return n.id;
    }).indexOf(id) > -1;
    var nodeId = isPresent ? id : nodes[0].id;
    !isPresent && state.api.setCurrentSlide(nodeId);
    return nodeId;
};
export default function beginLMSession(action$, state$) {
    return action$.pipe(ofType(BEGIN_LMS_SESSION), filter(function() {
        return state$.value.api.start();
    }), switchMap(function() {
        var actions = [
            setCurrentSlide({
                id: location.search.match(/c=(\d+)/) && parseInt(location.search.match(/c=(\d+)/)[1], 10) || getSavedIdIfExists(state$.value.api.getCurrentSlide(), state$.value.nodes.filter(function(n) {
                    return n.target_type !== "Filter";
                }), state$.value)
            }),
            setStudent({
                student: state$.value.api.getStudent()
            }),
            getCompletedSlides(),
            getFavorites(),
            getKeyValueStore(),
            getExamData(),
            logDebugMessage({
                message: " Adapter - ".concat(state$.value.api.id),
                messageType: "info",
                label: "LMS API"
            }),
            logDebugMessage({
                message: " SuspendData size - ".concat(JSON.stringify(state$.value.api.getSuspendData()).length, " of 4096 used"),
                messageType: "info",
                label: "LMS API"
            }),
            logDebugMessage({
                message: "Connected to LMS: student_id (".concat(state$.value.api.getStudent().id, "), student_name (").concat(state$.value.api.getStudent().name, ")"),
                messageType: "info",
                label: "LMS API"
            })
        ];
        if (!!state$.value.cbook.use_credit_points) {
            state$.value.api.setCBookInitialScores(state$.value.cbook);
            state$.value.api.setCBookObjectives(state$.value.nodes);
        }
        if (state$.value.api.getCBookStatus() === "not attempted") {
            state$.value.api.setCBookStatus("incomplete");
        }
        return actions;
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "begin_lms_session"
        }));
    }));
}
